import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import { Button, Container, Nav, Navbar } from 'react-bootstrap';
import { useCustomNavigate } from '../../utils/customNavigation';

function Navi() {
  const customNavigate = useCustomNavigate();
  return (

    <Navbar bg="light" expand="md" sticky="top" className='py-3'>
      <Container className="navbar-container ">
        <Navbar.Brand>
          <img
            src="/images/nomanejes.png"
            width={100}
            className="d-inline-block align-top"
            alt="Logo TCP"
            role="button"
            onClick={() => customNavigate('/#form-section-quote')}
          />
        </Navbar.Brand>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav className="nav-links ms-auto">
            <Nav.Link className='nav-link-normal mx-2' style={{ color: '#F15025' }} onClick={() => customNavigate('/#form-section-quote')}>Inicio</Nav.Link>
            <Nav.Link className='nav-link-normal mx-2' style={{ color: '#F15025' }} onClick={() => customNavigate('/#about-us')}>Sobre nosotros</Nav.Link>
            <Nav.Link className='nav-link-normal mx-2' style={{ color: '#F15025' }} onClick={() => customNavigate('/asesores')}>Nuestros Asesores</Nav.Link>
            <Nav.Link className='nav-link-normal mx-2' style={{ color: '#F15025' }} onClick={() => customNavigate('/terms')}>Terminos y condiciones</Nav.Link>
            <Nav.Link className='nav-link-normal mx-2' style={{ color: '#F15025' }} onClick={() => customNavigate('/blog')}>Blog</Nav.Link>
            <Button variant="outline-light" className='nav-button ms-2' onClick={() => customNavigate('/#form-section-quote')}>
              Cotizar
            </Button>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

export default Navi;
